import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import ClickAwayListener from 'react-click-away-listener';

import { ReactComponent as NotificationStatus } from '../../assets/icons/notification-item-status.svg';
import { useUserContext } from '../../context';
import { useFetchSettlementAccounts } from '../../hooks/queries';

const Notifications = ({ onClose }) => {
  const { user, userHasVerifiedEmail } = useUserContext();

  const { isKycVerified } = user;
  const { userHasSettlementAccounts } = useFetchSettlementAccounts();
  const messages = [
    {
      done: userHasVerifiedEmail,
      content: (
        <>
          You’re one step away from accepting crypto payments. Kindly verify your{' '}
          <b>email address.</b>
        </>
      )
    },
    {
      done: userHasSettlementAccounts,
      content: <>Create a settlement account to start accepting crypto payments now!</>
    },
    {
      done: isKycVerified,
      content: (
        <>
          To get started with basqet, we require some important information to access your identity{' '}
        </>
      )
    }
  ];
  return (
    <ClickAwayListener onClickAway={onClose}>
      <div className="navbar__notifications">
        <div className="navbar__notifications__header">
          <h3>Notifications</h3>
        </div>
        <div className="navbar__notifications__list">
          {messages
            .sort((a, b) => a.done - b.done)
            .map((message, idx) => (
              <NotificationItem message={message} key={idx} />
            ))}
        </div>
      </div>
    </ClickAwayListener>
  );
};

Notifications.propTypes = {
  onClose: PropTypes.func
};

const NotificationItem = ({ message }) => {
  const className = classNames({
    navbar__notifications__item: true,
    'navbar__notifications__item--done': message.done
  });
  return (
    <button className={className}>
      <span>
        <NotificationStatus />
        <p>{message.content}</p>
      </span>
    </button>
  );
};

NotificationItem.propTypes = {
  message: PropTypes.object
};

export { Notifications };
